export default __webpack_public_path__ + "static/media/class-success.419a1eba.svg";